export type EngagementEngine = 'v3' | 'astra';

export const isEngagementEngine = (value: unknown): value is EngagementEngine =>
  value === 'v3' || value === 'astra';
